enum AccessibleFeature {
  CONVERSIONS_LOG = 'conversionsLog',
  FACEBOOK_ACCOUNTS = 'facebookAccounts',
  FILES = 'files',
  TRIGGERS = 'triggers',
}

export default AccessibleFeature;
